import * as React from 'react';
import { DomUid } from './dom-uid';

export class BaseField<T> extends React.Component<T, any> {
    public uid = DomUid();
}



// WEBPACK FOOTER //
// ./src/components/libs/input-base.ts